import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-http-backend';
import Papa from 'papaparse';

const csvParser = (data, lng) => {
  const parsedData = Papa.parse(data).data;
  const translations = {};

  const languageIndex = parsedData[0].indexOf(lng);
  const supportedLngs = parsedData[0].slice(1);
  i18n.options.supportedLngs = supportedLngs;

  if (languageIndex !== -1) {
    parsedData.forEach((row) => {
      const key = row[0]; // Assuming the first column contains keys
      const translation = row[languageIndex];
      translations[key] = translation;
    });
  }
  return translations;
};

i18n.use(Backend).use(initReactI18next).init({
  fallbackLng: localStorage.getItem('lang') || 'en', // Default language fallback
  debug: true,

  backend: {
    loadPath: '/locales/master-translation.csv',
    parse: csvParser,
  },

  detection: {
    order: ['localStorage', 'navigator'],
  },
});

export default i18n;
